export default __webpack_public_path__ + "static/media/sample-villa.c1e5423f.jpg";